import YoutubePlayer from 'youtube-player';

$.ajaxSetup({ cache: true });

$.fn.embed = function(options){
    var defaults = {
      obj: $(this),
      objToEmbed: $(this),
      src: $(this).data('embed-src')
    }
    var settings = $.extend(defaults, options);

    // console.log(settings);

    let type = settings.src.split("/")[2];
    let src = "";
    if (type == "youtube.com" || type == "www.youtube.com") {
        type = "youtube";
        src = settings.src.split("=").slice(-1)[0];
    } else if (type == "twitch.tv" || type == "www.twitch.tv") {
        type = "twitch";
        src = settings.src.split("/").slice(-1)[0];

        console.log(type, src)
    }

    switch (type) {
        case 'youtube': 
            
            let outerYoutubeDom = `<div id="youtubeEmbed"></div>`;

            settings.objToEmbed.append(outerYoutubeDom);
            
            let ytplayer = new YoutubePlayer('youtubeEmbed', {
                videoId: src,
                playerVars: { 
                    // controls: 0,
                    rel: 0,
                    autoplay: 1,
                    color: 'white',
                    origin: 'http://esports.vng.games'

                }
            });

            ytplayer.playVideo();

            break;
        case 'twitch': 


            $.getScript('https://player.twitch.tv/js/embed/v1.js', function(){
                let outerTwitchDom = `<div id="twitchEmbed"></div>`;
    
                settings.objToEmbed.append(outerTwitchDom);

                let isAllNumbers = new RegExp('^\\d+$');
                if (isAllNumbers.test(src)) {
                    //is playback 
                    let twplayer = new Twitch.Player('twitchEmbed', {
                        video: src
                    });
                    twplayer.play();
                } else {
                    //is stream
                    let twplayer = new Twitch.Player('twitchEmbed', {
                        channel: src
                    });
                    twplayer.play();
                }
            });
            break;
        default: 
        
    }
    

}
